module.exports = __webpack_public_path__ + "media/images/application/icons/icon-octopus-black-a3b3265edb1f62697a670eb7a4f6d202.svg";